


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Covid19 extends Vue {
  @Prop({ type: String, required: true }) private title!: string;
  @Prop({ type: String, required: true }) private description!: string;
  @Prop({ type: Array, required: true }) private images!: [];
}
